module.exports = __webpack_public_path__ + "assets/img/about-phone-2.dbde2ddd.png";